import styled from 'styled-components';

export const Content = styled.main`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`;

export const TitleGraph = styled.h2`
  font-size: 22px;
  margin-top: 20px;
  text-align: center;
`;